<template>
  <icon-button icon="cross"
               class="button--close"
               :colour="colour"
               :size="size"
               :disabled="disabled"
               @click="$emit('click')"/>
</template>

<script>
import IconButton from './IconButton'

export default {
  name: 'CloseButton',
  components: { IconButton },
  props: {
    colour: {
      type: String,
      required: false,
      default: 'grey',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validate: ['small', 'medium', 'large'].includes,
    },
  },
}
</script>
